// extracted by mini-css-extract-plugin
module.exports = {"refundContent":"RefundPolicy_refundContent__qkH0Q","refundText":"RefundPolicy_refundText__2Fo0I"};